import { number, option, single, text, type UsFieldDef } from "../us-fields";

export const BLADDER_VOLUME = number("bladder.volume", "Bladder volume", "ml");

export const RENAL_BLADDER_FINDINGS: readonly UsFieldDef[] = [
  single(
    "bladder.distended",
    "Bladder distended",
    [option("no", "No"), option("yes", "Yes")],
    { normal: "no" },
  ),
  BLADDER_VOLUME,
  text("bladder.other_findings", "Other bladder findings"),
];

export const BLADDER_FINDINGS: readonly UsFieldDef[] = [
  BLADDER_VOLUME,
  single("bladder.foley", "Foley", [
    option("present", "Foley present in bladder"),
    option("not_present", "Foley not present in bladder"),
  ]),
  text("bladder.other_findings", "Other"),
];
